import React, { useState } from "react";
import HindcastsPanel from "../features/hindcasts-panel/HindcastsPanel";
import HindcastsTablePanel from "../features/hindcasts-table/HindcastsTablePanel";
import HindcastsTableTopbar from "../features/hindcasts-table/HindcastsTableTopbar";
import NoSite from "../features/hindcasts-panel/NoSite";
import CenteredLoading from "../common/CenteredLoading";
import FileDownload from "js-file-download";
// import ConfirmationDialog from "../common/Confirmation";
// import { initialConfirmDialog } from "../common/Confirmation";

const HindcastsPage = (props) => {
    const { container, mobile, tablet } = props;
    const [tableData, setTableData] = useState(null);
    const [failedParameters, setFailedParameters] = useState([]);
    const [coordinates, setCoordinates] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedPercentile, setSelectedPercentile] = useState("None");

    const title =
        coordinates !== null
            ? "Lat: " + coordinates.latitude + " Lon: " + coordinates.longitude
            : "";

    const percentileOptions = [
        "None",
        "P10",
        "P20",
        "P30",
        "P40",
        "P50",
        "P60",
        "P70",
        "P80",
        "P90",
    ];

    const handlePercentileChange = (event) => {
        setSelectedPercentile(event.target.value);
    };

    const replacer = (key, value) => (value === null ? "" : value);

    const generateAnalysisCsv = (data, selectedPercentile) => {
        let header = [
            "Year",
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
            "Average",
        ];
        header =
            selectedPercentile !== "None"
                ? header.concat(selectedPercentile)
                : header;
        const csv = [
            header.join(","),
            ...data
                .filter(
                    (item) =>
                        item.Year.toString().indexOf("P") < 0 ||
                        item.Year.toString() === selectedPercentile,
                )
                .map((row) =>
                    header
                        .map((fieldName) =>
                            JSON.stringify(row[fieldName], replacer),
                        )
                        .join(","),
                ),
        ].join("\r\n");
        return csv;
    };

    const downloadAnalysisData = () => {
        if (tableData) {
            FileDownload(
                generateAnalysisCsv(tableData, selectedPercentile),
                "hindcast_analysis_results.csv",
            );
        }
    };

    // const [confirmation, setConfirmation] = useState(initialConfirmDialog);

    const [nodataContent, setNodataContent] = useState({
        heading: "No data",
        body: "Enter correct coordinates and submit",
    });

    // const resetConfirmation = () => {
    //     setConfirmation(initialConfirmDialog);
    // };

    const resultPanel = () => {
        return tableData !== null ? (
            <>
                <HindcastsTableTopbar
                    title={title}
                    selectedPercentile={selectedPercentile}
                    handlePercentileChange={handlePercentileChange}
                    percentileOptions={percentileOptions}
                    downloadAnalysisData={downloadAnalysisData}
                ></HindcastsTableTopbar>
                <HindcastsTablePanel
                    data={tableData}
                    failedParameters={failedParameters}
                    loading={loading}
                    selectedPercentile={selectedPercentile}
                ></HindcastsTablePanel>
            </>
        ) : (
            <NoSite
                {...props}
                creating={false}
                mobile={mobile}
                heading={nodataContent.heading}
                body={nodataContent.body}
            ></NoSite>
        );
    };

    //  setLoading(true);
    const resetLoading = {
        position: "relative",
        marginLeft: "407",
    };
    return (
        <>
            <HindcastsPanel
                toggleable={tablet}
                container={container}
                setTableData={setTableData}
                setFailedParameters={setFailedParameters}
                loading={loading}
                setLoading={setLoading}
                setNodataContent={setNodataContent}
                setCoordinates={setCoordinates}
            >
                {/* <ConfirmationDialog {...confirmation} /> */}
                {!loading ? (
                    resultPanel()
                ) : (
                    <CenteredLoading className={{ resetLoading }} />
                )}
            </HindcastsPanel>
        </>
    );
};

export default HindcastsPage;
